<lib-checkbox [disabled]="disabled()"
              [indeterminate]="masterIndeterminate()"
              [selected]="masterSelected()"
              (checkboxClick)="masterClicked()"
              i18n>
  Select All
</lib-checkbox>
